import React from "react";
import { Outlet } from "react-router-dom";

const OnBoardLayout = () => {


    return (
        <>
            <div className='noheader'>
                <Outlet/>
            </div>

        </>
    );
}

export default OnBoardLayout;